"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var react_number_format_1 = require("react-number-format");
var context_1 = require("../../context/context");
var web3_candies_1 = require("@defi.org/web3-candies");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var Loader_1 = require("./Loader");
function NumericInput(_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.prefix, prefix = _c === void 0 ? "" : _c, onChange = _a.onChange, value = _a.value, _d = _a.disabled, disabled = _d === void 0 ? false : _d, placeholder = _a.placeholder, onFocus = _a.onFocus, onBlur = _a.onBlur, _e = _a.loading, loading = _e === void 0 ? false : _e, _f = _a.className, className = _f === void 0 ? "" : _f, maxValue = _a.maxValue, decimalScale = _a.decimalScale, minAmount = _a.minAmount;
    var inputValue = value || minAmount || "";
    var _g = (0, context_1.useTwapContext)().uiPreferences, inputPlaceholder = _g.inputPlaceholder, disableThousandSeparator = _g.disableThousandSeparator;
    var _placeholder = placeholder || inputPlaceholder || "0.0";
    return ((0, jsx_runtime_1.jsxs)(StyledContainer, __assign({ className: "twap-input ".concat(className), style: style }, { children: [loading && (0, jsx_runtime_1.jsx)(StyledLoader, { className: "twap-input-loader", width: "75%", height: "60%" }), (0, jsx_runtime_1.jsx)(StyledFlex, __assign({ style: { height: "100%" }, className: "".concat(loading ? "twap-input-loading" : "") }, { children: (0, jsx_runtime_1.jsx)(react_number_format_1.NumericFormat, { allowNegative: false, disabled: disabled, decimalScale: decimalScale, onBlur: onBlur, onFocus: onFocus, placeholder: _placeholder, isAllowed: function (values) {
                        var _a = values.floatValue, floatValue = _a === void 0 ? 0 : _a;
                        return maxValue ? floatValue <= parseFloat(maxValue) : (0, bignumber_js_1.default)(floatValue).isLessThanOrEqualTo(web3_candies_1.maxUint256);
                    }, prefix: prefix ? "".concat(prefix, " ") : "", value: disabled && value === "0" ? "" : inputValue, thousandSeparator: disableThousandSeparator ? undefined : ",", decimalSeparator: ".", customInput: StyledInput, type: "text", min: minAmount, onValueChange: function (values, _sourceInfo) {
                        if (_sourceInfo.source !== "event") {
                            return;
                        }
                        onChange(values.value === "." ? "0." : values.value);
                    } }) }))] })));
}
exports.default = NumericInput;
var StyledLoader = (0, styled_components_1.default)(Loader_1.Loader)({
    position: "absolute",
    top: "50%",
    transform: "translate(0, -50%)",
});
var StyledContainer = (0, styled_components_1.default)("div")({
    flex: 1,
    height: "100%",
    position: "relative",
});
var StyledInput = (0, styled_components_1.default)("input")(function (_a) {
    var disabled = _a.disabled;
    return ({
        pointerEvents: disabled ? "none" : "unset",
        height: "100%",
        width: "100%",
        fontSize: 16,
        border: "unset",
        background: "transparent",
        outline: "unset",
        fontWeight: 500,
    });
});
var StyledFlex = (0, styled_components_1.default)("div")({
    display: "flex",
    alignItems: "center",
});
